import refs from '../helpers/refs'

class C3upBlocks {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-3up-blocks')
    .forEach(el => new C3upBlocks(el))
})
